import React from 'react'

import { FlowList } from '@/containers/FlowList'
import { useCurrentAppId } from '@/hooks/useApplication'

const FlowPage: React.FC = () => {
    const appId = useCurrentAppId()

    return <FlowList appId={appId} />
}

export default FlowPage
